import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'src/store/selectors';
import { OrganizationDto } from 'src/types/organizations';
import {
  getOrganizationById,
  getOrganizationGeneralInfo,
  getOrganizationStudies,
} from './organizations';
import { configuration } from 'src/configuration';
import { Study } from 'src/types/studies';

export function useGetOrganization(organizationId: string | undefined) {
  const token = useSelector(selectAuthToken);

  return useQuery<OrganizationDto>({
    queryKey: ['organization', organizationId],
    queryFn: async () => {
      if (organizationId) {
        return await getOrganizationById({ token, id: organizationId });
      }
    },
    staleTime: configuration.queriesStaleTime,
  });
}

export function useGetOrganizationGeneralInfo(organizationId: string | undefined) {
  const token = useSelector(selectAuthToken);

  return useQuery<OrganizationDto>({
    queryKey: ['organization-general-info', organizationId],
    queryFn: async () => {
      if (organizationId) {
        return await getOrganizationGeneralInfo({ token, id: organizationId });
      }
    },
    staleTime: configuration.queriesStaleTime,
  });
}

export function useGetOrganizationStudies(organizationId: string | undefined) {
  const token = useSelector(selectAuthToken);

  return useQuery<{ studies: Study[] }>({
    queryKey: ['organization-studies', organizationId],
    queryFn: async () => {
      if (organizationId) {
        return await getOrganizationStudies({ token, organizationId });
      }
      return { studies: [] };
    },
    staleTime: configuration.queriesStaleTime,
  });
}
